import localScaleManager from "../../../../helpers/LocalScaleManager";
import { Parser } from "../../../../helpers/parser";
import { tweenConfigs } from "../../../../helpers/tweensConfigs";

export class Bet {
  /**
   * @param scene {GameScene}
   * @param table {Table}
   * @param isMyTable {boolean}
   */
  constructor(scene, table, isMyTable) {
    this.scene = scene;
    this.table = table;
    this.isMyTable = isMyTable;
    this.bet = 0;

    // this.textBox = this.scene.add
    //   .image(0, 0, this.scene.atlasTexture, "chip-text-box")
    //   .setOrigin(0)
    //   .setDepth(5);
    // this.table.poolArray.push(this.textBox);

    this.text = this.scene.add.bitmapText(
      0,
      0,
      "HelveticaNeue",
      Parser.convertToXLetters(Parser.toCurrency(""), 8)
    );
    this.text.setData("width", this.text.width).setDepth(6).setOrigin(.5);
    this.text.setData("height", this.text.height);
    this.table.poolArray.push(this.text);
    // this.text.setText(Parser.convertToXLetters('0', 8));
    this.chips = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "red-chip")
      .setOrigin(0);
    this.table.poolArray.push(this.chips);

    this.clonedChipsToStack = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "red-chip")
      .setDepth(11)
      .setOrigin(0)
      .setVisible(false);
    this.table.poolArray.push(this.clonedChipsToStack);

    this.clonedChipsToAdd = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "red-chip")
      .setOrigin(0)
      .setVisible(false);
    this.table.poolArray.push(this.clonedChipsToAdd);

    this.hiddenChipX = 0;
    this.hiddenChipY = 0;
    this.showChipsTweenDuration = tweenConfigs.playerChips.show.duration;
    this.stackChipsTweenDuration = tweenConfigs.playerChips.stack.duration;
    this.stackChipsTweenDelay = this.showChipsTweenDuration * 2;
    this.visibilityControls(false);
    // this.chips.setTint(0x00ff00)
  }
  visibilityControls(visibility) {
    // if (this.textBox.visible !== visibility)
    //   this.textBox.setVisible(visibility);
    if (this.chips.visible !== visibility) this.chips.setVisible(visibility);
    if (this.text.visible !== visibility) this.text.setVisible(visibility);
  }
  async updatePlayerBet(playerInfo, delay = 0) {
    const preBet = this.bet,
      newBet = playerInfo.bet;
    this.bet = playerInfo.bet;
    if (newBet) {
      if (preBet !== newBet) {
        if (preBet) {
          await this.addChips(this.bet, delay);
        } else {
          await this.showChips(this.bet, delay);
        }
      } else {
        this.visibilityControls(true);
      }
    } else if (!this.table.gameState.newState) this.visibilityControls(false);
    return "done";
  }
  showChips(bet, delay = 0) {
    this.chips.x = this.hiddenChipX;
    this.chips.y = this.hiddenChipY;
    if (!this.chips.visible) this.chips.setVisible(true);
    return new Promise((resolve) => {
      if (this.scene.tweenEnable && !this.table.firstGameState) {
        this.scene.tweens.add({
          targets: this.chips,
          x: this.chips.getData("initX"),
          y: this.chips.getData("initY"),
          duration: this.showChipsTweenDuration,
          ease: tweenConfigs.playerChips.show.ease,
          delay: delay,
          onComplete: () => {
            this.text.setText(
              // Parser.convertToXLetters(Parser.toCurrency(bet), 8)
              Parser.toCurrency(bet)
            );
            // this.text.setPosition(this.chips.x + this.chips.displayWidth * 1.4, this.chips.y + this.chips.displayHeight * 0.1);
            // this.textBox.setPosition(this.text.x + (this.text.width - this.textBox.displayWidth) / 2, this.text.y + (this.text.height - this.textBox.displayHeight) / 2);
            this.visibilityControls(true);
            this.chips.x = this.chips.getData("initX");
            this.chips.y = this.chips.getData("initY");
            resolve();
          },
        });
      } else {
        this.chips.setPosition(
          this.chips.getData("initX"),
          this.chips.getData("initY")
        );
        // this.text.setText(Parser.convertToXLetters(Parser.toCurrency(bet), 8));
        this.text.setText(Parser.toCurrency(bet));
        // this.text.setPosition(this.chips.x + this.chips.displayWidth * 1.4, this.chips.y + this.chips.displayHeight * 0.1);
        // this.textBox.setPosition(this.text.x + (this.text.width - this.textBox.displayWidth) / 2, this.text.y + (this.text.height - this.textBox.displayHeight) / 2);
        this.visibilityControls(true);
        resolve();
      }
    });
  }
  addChips(bet, delay = 0) {
    this.clonedChipsToAdd.setPosition(this.hiddenChipX, this.hiddenChipY);
    if (!this.clonedChipsToAdd.visible) this.clonedChipsToAdd.setVisible(true);
    this.visibilityControls(true);
    return new Promise((resolve) => {
      if (this.scene.tweenEnable) {
        this.scene.tweens.add({
          targets: this.clonedChipsToAdd,
          x: this.chips.getData("initX"),
          y: this.chips.getData("initY"),
          duration: this.showChipsTweenDuration,
          ease: tweenConfigs.playerChips.show.ease,
          delay: delay,
          onComplete: () => {
            this.text.setText(
              // Parser.convertToXLetters(Parser.toCurrency(bet), 8)
              Parser.toCurrency(bet)
            );
            if (this.clonedChipsToAdd.visible)
              this.clonedChipsToAdd.setVisible(false);
            this.clonedChipsToAdd.setPosition(
              this.hiddenChipX,
              this.hiddenChipY
            );
            resolve();
          },
        });
      } else {
        this.clonedChipsToAdd.setPosition(
          this.chips.getData("initX"),
          this.chips.getData("initY")
        );
        // this.text.setText(Parser.convertToXLetters(Parser.toCurrency(bet), 8));
        this.text.setText(Parser.toCurrency(bet));
        if (this.clonedChipsToAdd.visible)
          this.clonedChipsToAdd.setVisible(false);
        resolve();
      }
    });
  }
  returnChipsToPlayer(bet) {
    this.clonedChipsToAdd.setPosition(
      this.chips.getData("initX"),
      this.chips.getData("initY")
    );
    if (!this.clonedChipsToAdd.visible) this.clonedChipsToAdd.setVisible(true);
    this.visibilityControls(true);
    return new Promise((resolve) => {
      if (this.scene.tweenEnable) {
        this.scene.tweens.add({
          targets: this.clonedChipsToAdd,
          x: this.hiddenChipX,
          y: this.hiddenChipY,
          duration: this.showChipsTweenDuration,
          ease: tweenConfigs.playerChips.show.ease,
          delay: this.stackChipsTweenDelay,
          onComplete: () => {
            // this.text.setText(Parser.convertToXLetters(bet.toLocaleString() , 11));
            if (this.clonedChipsToAdd.visible)
              this.clonedChipsToAdd.setVisible(false);
            this.clonedChipsToAdd.setPosition(
              this.chips.getData("initX"),
              this.chips.getData("initY")
            );
            resolve();
          },
        });
      } else {
        this.clonedChipsToAdd.setPosition(this.hiddenChipX, this.hiddenChipY);
        if (this.clonedChipsToAdd.visible)
          this.clonedChipsToAdd.setVisible(false);
        this.visibilityControls(false);
        resolve();
      }
    });
  }

  stackChips(x, y) {
    if (this.scene.tweenEnable) {
      this.table.pots.handleGameState(this.table.gameState);
      this.scene.tweens.add({
        targets: this.clonedChipsToStack,
        x: x,
        y: y,
        delay: this.stackChipsTweenDelay,
        duration: this.stackChipsTweenDuration, //
        ease: tweenConfigs.playerChips.stack.ease,
        onStart: () => {
          if (!this.clonedChipsToStack.visible)
            this.clonedChipsToStack.setVisible(true);
          this.visibilityControls(false);
          this.table.sounds.play("stack-chips");
        },
        onComplete: () => {
          if (this.clonedChipsToStack.visible)
            this.clonedChipsToStack.setVisible(false);
          this.clonedChipsToStack.setPosition(
            this.chips.getData("initX"),
            this.chips.getData("initY")
          );
        },
      });
    } else {
      if (this.clonedChipsToStack.visible)
        this.clonedChipsToStack.setVisible(false);
      this.clonedChipsToStack.setPosition(
        this.chips.getData("initX"),
        this.chips.getData("initY")
      );
      this.visibilityControls(false);
    }
  }
  // handleVisibilityChange(hidden) {
  //   let activeTweens, activeTweensClonedChipsToStack;
  //   if (hidden) {
  //     /* agar game hidden shod va active tween dashtim bayad hame ra foran b payan bbarim
  //      * ba tavajoh b inke agr tweeni k montazer etmam delay ast ra seek konim onStart on tween ejra nemishavad
  //      */
  //     activeTweens = this.scene.tweens.getTweensOf([
  //       this.chips,
  //       this.clonedChipsToAdd,
  //     ]);
  //     activeTweens.forEach((tween) => {
  //       tween.seek(1);
  //     });
  //     activeTweensClonedChipsToStack = this.scene.tweens.getTweensOf(
  //       this.clonedChipsToStack
  //     );
  //     activeTweensClonedChipsToStack.forEach((tween) => {
  //       this.visibilityControls(false);
  //       tween.targets.forEach((t) => t.setVisible(true));
  //       tween.seek(1);
  //     });
  //   }
  // }
  /***
   *
   * @param width {number} width of seat box
   * @param height {number} width of seat box
   * @param initX {number} seat box top left x
   * @param initY {number} seat box top left y
   */
  positionControls(width, height, initX, initY) {
    this.hiddenChipX = initX;
    this.hiddenChipY = initY;
    const chipsSize = this.isMyTable ? width * 0.21 : width * 0.29;
    // const chipsSize = width * .29;
    localScaleManager.scaleSprite(this.chips, chipsSize, chipsSize, 0, 1, true);
    this.clonedChipsToStack.setScale(this.chips.scale);
    this.clonedChipsToAdd.setScale(this.chips.scale);

    // localScaleManager.scaleSprite(
    //   this.textBox,
    //   this.chips.displayWidth * 4,
    //   this.chips.displayHeight,
    //   0,
    //   1,
    //   true
    // );
    // this.textBox.
    // this.textBox.height = this.chips.height;
    // this.textBox.setPosition(
    //   this.chips.x + this.chips.displayWidth,
    //   this.chips.y + (this.chips.displayHeight - this.textBox.displayHeight) / 2
    // );

    // const textSize = this.isMyTable ? width / 2.5 : width / 1.5;
    // const textSize = width / 1.5;
    localScaleManager.scaleBitMapText(
      this.text,
      this.chips.displayWidth * 2,
      this.chips.displayHeight * 0.65,
      0,
      1,
      false
    );
    this.text.setPosition(
      this.chips.x + this.chips.displayWidth / 2,
      this.chips.y + this.chips.displayHeight * 1.2
    );

    this.chips.setData("initX", this.chips.x);
    this.chips.setData("initY", this.chips.y);
    this.clonedChipsToStack.setPosition(this.chips.x, this.chips.y);
  }
  /***
   *
   * @param width {number} width of seat box
   * @param height {number} width of seat box
   * @param initX {number} seat box top left x
   * @param initY {number} seat box top left y
   */
  reposition(width, height, initX, initY) {
    this.hiddenChipX = initX;
    this.hiddenChipY = initY;

    // this.textBox.setPosition(
    //   this.chips.x + this.chips.displayWidth,
    //   this.chips.y + (this.chips.displayHeight - this.textBox.displayHeight) / 2
    // );

    this.text.setPosition(
      this.chips.x + this.chips.displayWidth / 2,
      this.chips.y + this.chips.displayHeight * 1.2
    );

    this.chips.setData("initX", this.chips.x);
    this.chips.setData("initY", this.chips.y);
    this.clonedChipsToStack.setPosition(this.chips.x, this.chips.y);
  }
  remove() {
    this.chips.destroy();
    this.clonedChipsToAdd.destroy();
    this.clonedChipsToStack.destroy();
    this.text.destroy();
    // this.textBox.destroy();
  }
}
